/* eslint-disable */
let isDev = ['test', 'development'].includes(process.env.NODE_ENV)
export default [
  {
    name: '平台管理', icon: 'icon_platform', path: '/vip', children: [
      { name: '会员申请', path: '/vip/apply' }
    ]
  }
  // {
  //   name: '招考管理', icon: 'icon_batch', path: '/batch', children: [
  //     {
  //       name: '考试管理', path: '/batch/batch', hideChildren: true, children: [
  //         { name: '考试编辑', path: '/batch/batch-edit', hide: true },
  //       ]
  //     },
  //     {
  //       name: '科目类型管理', path: '/batch/subject', hideChildren: true, children: [
  //         { name: '科目类型编辑', path: '/batch/subject-edit', hide: true },
  //       ]
  //     },
  //     {
  //       name: '考试内容管理', path: '/batch/specialty', hideChildren: true, children: [
  //         {
  //           name: '专业级别管理', path: '/batch/grade', hide: true, hideChildren: true, children: [
  //             { name: '设置考试科目', path: '/batch/grade-edit', hide: true },
  //           ]
  //         },
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: '资讯管理', icon: 'icon_article', path: '/article', children: [
  //     { name: 'banner配置', path: '/article/banner' },
  //     {
  //       name: '资讯内容管理', path: '/article/article', hideChildren: true, children: [
  //         { name: '资讯内容编辑', path: '/article/article-edit', hide: true },
  //       ]
  //     }
  //   ]
  // },
  // {
  //   name: '考生管理', icon: 'icon_order', path: '/order', children: [
  //     {
  //       name: '考生报名列表管理', path: '/order/order', hideChildren: true, children: [
  //         { name: '考生报考信息', path: '/order/order-edit', hide: true },
  //         { name: '考生报考科目', path: '/order/order-question-edit', hide: true },
  //       ]
  //     },
  //     { name: '退款订单管理', path: '/order/refund' },
  //     {
  //       name: '白名单管理', path: '/order/white-list', hideChildren: true,
  //       children: [
  //         { name: '新增白名单', path: '/order/white-list-edit', hide: true }
  //       ]
  //     },
  //     {
  //       name: '重考名单', path: '/order/redo', hideChildren: true,
  //       children: [
  //         { name: '选择重考考生', path: '/order/redo-select', hide: true }
  //       ]
  //     }
  //   ]
  // },
  // { name: '考试结果记录', icon: 'icon_batch', path: '/exam/exam-result' },
  // { name: '人脸审核', icon: 'icon_batch', path: '/exam/face' },
  // {
  //   name: '审核管理', icon: 'icon_workflow', path: '/workflow', children: [
  //     { name: '考试费用审核管理', path: '/workflow/fee' },
  //     { name: '考试时间审核管理', path: '/workflow/time' }
  //   ]
  // },
  // {
  //   name: '统计管理', icon: 'icon_workflow', path: '/statistical', hide: !isDev, hideChildren: !isDev, children: [
  //     { name: '考试报名统计', path: '/statistical/enroll' },
  //     { name: '考试统计', path: '/statistical/exam' }
  //   ]
  // },
  // {
  //   name: '评分管理', icon: 'icon_check-item-filling', path: '/evaluation', children: [
  //     {
  //       name: '考试管理', path: '/evaluation/setting', hideChildren: true, children: [
  //         { name: '编辑评分模板', path: '/evaluation/setting-edit', hide: true },
  //         { name: '编辑评委分组', path: '/evaluation/room-edit', hide: true },
  //         { name: '编辑评委分组', path: '/evaluation/newroom-edit', hide: true }
  //       ]
  //     },
  //     {
  //       name: '考场管理', path: '/evaluation/room', hideChildren: true, children: [
  //         {
  //           name: '考生信息列表', path: '/evaluation/exam', hide: true, hideChildren: true, children: [
  //             { name: '查看视频', path: '/evaluation/video', hide: true },
  //           ]
  //         },
  //       ]
  //     },
  //     { name: '评语管理', path: '/evaluation/remark' },
  //     { name: '考试人数管理', path: '/evaluation/summary' },
  //     {
  //       name: '考生成绩管理', path: '/evaluation/performance', hideChildren: true, children: [
  //         { name: '查看考生成绩', path: '/evaluation/performance-edit', hide: true },
  //       ]
  //     },
  //     {
  //       name: '证书生成', path: '/evaluation/certificate', hideChildren: true, children: [
  //         { name: '打印证书', path: '/evaluation/printing', hide: true },
  //       ]
  //     }
  //   ]
  // }
]
